import Cookies from "js-cookie";
export const BASE_URL = process.env.REACT_APP_SERVER_URL;

class Auth {
  getCipher(): string | null {
    return Cookies.get("presidential-cipher") || null;
  }

  setCipher(token: string): void {
    Cookies.set("presidential-cipher", token, { expires: 1 }); // expire 24 hours
  }

  clearCipher(): void {
    Cookies.remove("presidential-cipher");
  }
}

export default new Auth();
